import {
  enumScrollBarButtonType,
  enumScrollBarType,
  kScrollBarButtonSize,
  kScrollBarThickness
} from "../constants";
import { QElement } from "./QElement";
import { QScrollBarButton } from "./QScrollBarButton";
import { QScrollBarSlug } from "./QScrollBarSlug";
import { Globals } from "./Globals";

export class QScrollBar extends QElement {
  constructor() {
    super();
    this.fAvailableWidth = null;
    this.fParentPanel = null;

    this.fParentX = null;
    this.fParentY = null;

    this.fTargetPanel = null;
    this.fSlug = null;
    this.fTrackSize = null;

    this.fButton1 = null;
    this.fButton2 = null;

    this.fScrollBarType = null;
  }

  InitScrollBar(parentPanel, targetPanel, scrollBarType) {
    this.fParentPanel = parentPanel;
    this.fTargetPanel = targetPanel;

    this.fScrollBarType = scrollBarType;
    this.fParentX = parentPanel.GetPositionX();
    this.fParentY = parentPanel.GetPositionY();

    this.SetFillColor(parentPanel.GetFillColor());

    var slug = new QScrollBarSlug();
    slug.InitSlug(this, scrollBarType);
    this.fHasButtons = false;
    if (this.fHasButtons) this.InitScrollBarButtons();

    this.UpdateScrollBar();

    this.SetCmdCode("scrollTrack");
  }

  InitScrollBarButtons() {
    var scrollBarType = this.fScrollBarType;

    if (scrollBarType == enumScrollBarType.horizontal) {
      var leftButton = new QScrollBarButton();
      leftButton.InitScrollButton(
        this,
        this.fParentPanel,
        this.fTargetPanel,
        enumScrollBarButtonType.left
      );
      var rightButton = new QScrollBarButton();
      rightButton.InitScrollButton(
        this,
        this.fParentPanel,
        this.fTargetPanel,
        enumScrollBarButtonType.right
      );
    } else {
      var topButton = new QScrollBarButton();
      topButton.InitScrollButton(
        this,
        this.fParentPanel,
        this.fTargetPanel,
        enumScrollBarButtonType.up
      );
      var bottomButton = new QScrollBarButton();
      bottomButton.InitScrollButton(
        this,
        this.fParentPanel,
        this.fTargetPanel,
        enumScrollBarButtonType.down
      );
    }
  }

  HandleTrackClick(x, y) {
    var theSlug = this.fSlug;
    var curSlugX = theSlug.GetPositionX();
    var curSlugY = theSlug.GetPositionY();
    if (!theSlug.IsShown()) {
      return;
    }
    if (
      this.fScrollBarType === enumScrollBarType.vertical &&
      curSlugY != null &&
      !isNaN(curSlugY)
    ) {
      var topBound = this.fParentY + theSlug.fVertOffset;
      var bottomBound = topBound + theSlug.fSlugSize;
      y > bottomBound
        ? theSlug.MoveElement(0, y - bottomBound)
        : theSlug.MoveElement(0, y - topBound);
    } else if (
      this.fScrollBarType === enumScrollBarType.horizontal &&
      curSlugX != null &&
      !isNaN(curSlugX)
    ) {
      var leftBound = this.fParentX + this.fHorzOffset + theSlug.fHorzOffset;
      var rightBound = leftBound + theSlug.fSlugSize;
      x > rightBound
        ? theSlug.MoveElement(x - rightBound, 0)
        : theSlug.MoveElement(x - leftBound, 0);
    }
  }

  RenderScrollBar(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var thickness = 1;
    ctx.save();

    ctx.fillStyle = this.GetFillColor();
    ctx.fillRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);
    ctx.restore();
  }

  DoRenderElement(drawBuffer) {
    if (
      (this.fScrollBarType === enumScrollBarType.horizontal &&
        this.fParentPanel.GetHasHorzScrollBar()) ||
      (this.fScrollBarType === enumScrollBarType.vertical &&
        this.fParentPanel.GetHasVertScrollBar())
    ) {
      this.RenderScrollBar(drawBuffer);
      this.fSlug.RenderScrollBarSlug(drawBuffer);
      if (this.fHasButtons) {
        this.fButton1.RenderScrollBarButton(drawBuffer);
        this.fButton2.RenderScrollBarButton(drawBuffer);
      }
      if (
        this.fParentPanel.GetHasVertScrollBar() &&
        this.fParentPanel.GetHasHorzScrollBar() &&
        this.fScrollBarType === enumScrollBarType.vertical
      ) {
        //Draw the lower right corner box.
        var ctx = drawBuffer.getContext("2d");
        ctx.save();
        ctx.fillStyle = this.GetFillColor();
        ctx.fillRect(
          this.fHorzOffset,
          this.fVertOffset + this.fHeight,
          this.fWidth,
          kScrollBarThickness
        );
        ctx.restore();
      }
    }
  }

  GetScrollBarTargetPanel() {
    return this.fTargetPanel;
  }

  GetScrollBarBackgroundPanel() {
    return this.fParentPanel;
  }

  SetScrollBarTargetPanel(targetPanel) {
    this.fTargetPanel = targetPanel;
  }

  UpdateSlug() {
    this.fSlug.UpdateSlug();
  }

  UpdateScrollBar() {
    var scrollBarType = this.fScrollBarType;
    var parentPanel = this.fParentPanel;
    var WSMgr = Globals._wsMgr;

    if (!WSMgr.GetCurrentPanel() || WSMgr.GetCurrentPanel() !== parentPanel.fPortPanel) {
      //WSMgr.fCurrentPanel = parentPanel.fPortPanel;
      //console.log('Possible Scrollbar Target Mismatch');
    }
    if (!this.GetScrollBarTargetPanel()) {
      console.log("Scrollbar Target Failure");
      return;
    }

    var parentWidth = parentPanel.GetWidth();
    var parentHeight = parentPanel.GetHeight();

    var buttonCompensate = 0;
    if (scrollBarType === enumScrollBarType.horizontal) {
      this.SetHeight(kScrollBarThickness);

      if (parentPanel.GetHasVertScrollBar()) buttonCompensate += kScrollBarButtonSize;
      if (this.fStartX == null || this.fMaxX == null) {
        this.SetWidth(parentWidth - buttonCompensate);
      } else {
        this.SetWidth(this.fMaxX - this.fStartX - buttonCompensate);
      }

      var xPos = this.fStartX ? this.fStartX : 0;
      var yPos = this.fStartY ? this.fStartY : parentHeight - this.GetHeight();

      this.PositionElement(xPos, yPos);

      if (this.fHasButtons) this.fTrackSize = this.GetWidth() - 2 * kScrollBarButtonSize;
      else this.fTrackSize = this.GetWidth();
    }
    if (scrollBarType === enumScrollBarType.vertical) {
      this.SetWidth(kScrollBarThickness);
      if (parentPanel.GetHasHorzScrollBar() || parentPanel.fButtonCompensateOverride)
        buttonCompensate += kScrollBarButtonSize;
      if (this.fStartY == null || this.fMaxY == null) {
        this.SetHeight(parentHeight - buttonCompensate);
      } else {
        this.SetHeight(this.fMaxY - this.fStartY - buttonCompensate);
      }
      var xPos = this.fStartX ? this.fStartX : parentWidth - this.GetWidth();
      var yPos = this.fStartY ? this.fStartY : 0;
      this.PositionElement(xPos, yPos);

      if (this.fHasButtons) this.fTrackSize = this.GetHeight() - 2 * kScrollBarButtonSize;
      else this.fTrackSize = this.GetHeight();
    }

    this.UpdateSlug();
    if (this.fHasButtons) {
      this.fButton1.UpdateScrollButton();
      this.fButton2.UpdateScrollButton();
    }
  }
}
